/* eslint-disable jsx-a11y/anchor-is-valid */
import Medica from "../../../assets/images/medica.png";
import MainFilter from "../MainFilter";
import MainInput from "../MainInput";

const PageHeader = () => {
  return (
    <div className="page-header home">
      <div className="shape"></div>
      <div className="image-header" style={{backgroundImage:`url(${Medica})`}}></div>
      <div className="container position-relative z-5">
        <div className="text-header">
          <h1 className="mb-4">
            Encontre o melhor profissional para atendê-lo
          </h1>
          <p className="mb-4">
            Agende consultas presenciais ou por vídeo com especialistas —
            escolha o dia, o horário e o local de atendimento que funcionam
            melhor para você.
          </p>
        </div>
        <MainInput />
        <MainFilter />
      </div>
    </div>
  );
};

export default PageHeader;
